export const environmentDefaults = {
  production: false,
  enableDebugInterceptors: false,
  contentful: {
    space: 'fbth0d1d3tpo',
    accessToken: 'b0b2fa9aba9cfd32562a08d1eb49212ff7ffe2db53af5664307f5d6a7b7231c4',
    environment: 'Development',
  },
  timezone: 'America/Chicago',
  logging: {
    debugMode: true,
  },
  services: {
    producerId: '90cc2cdd-ddd5-4cec-810e-60c31d093c5e',
    placeholderParentIdForTopLevelEntities: 'c706ca24-02a3-465f-aed2-6be67eb2d0d5',
  },
  netSuite: {
    companyId: '3290460_SB1',
    baseUrl: 'https://3290460-sb1.app.netsuite.com/app/login/secure/oidcprivate.nl',
    myAccountBaseUrl: 'sandbox.incomingfiles.com',
  },
  userRegex: /((?:svc_dev_cognito|loadtest)[\w.+-]*@(?:tasconline|sharklasers)\.com)|([\w.+-]+@(?:tascacm\.com|tascinc\.co))$/,
};
